import { useFormContext } from 'react-hook-form';
import Stack from '@ui/layout/Stack';
import Text from '@ui/atoms/Text';
import { FormattedMessage } from 'react-intl';
import { ToggleController } from '@ui/atoms/Toggle';

const EpisodeEditFormNewsletterEnabledField = () => {
    const { control } = useFormContext();

    return (
        <Stack $gap="1rem">
            <Text variant="bodyM" fontWeight="--fw-semibold">
                <FormattedMessage defaultMessage="Activer la newsletter" />
            </Text>
            <ToggleController name="activated" control={control}>
                <FormattedMessage defaultMessage="Permettre à vos auditeurs de s'abonner à votre newsletter" />
            </ToggleController>
        </Stack>
    );
};

export default EpisodeEditFormNewsletterEnabledField;
